<template>
  <div :class="['content-box', { 'no-card': disableCard }]">
    <div :class="['card-body', { 'no-card': disableCard }]">
      <span class="egx-partner-color">
        <h2 v-html="header.title" />
      </span>
      <div v-html="header.description" />
      <applicationCard class="mt-4" @number-of-applications="updateApplicationSize"/>
      <div
        class="text-center"
        v-if="isApplyButtonVisible"
      >
        <a
          :class="applications_details.view_button.class"
          :style="applications_details.view_button.style"
          :href="applications_details.view_button.path"
          :target="applications_details.view_button.open_in_new_tab ? '_blank' : '_self'"
        >
          {{ applications_details.view_button.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import mockData from '../mockData';
import applicationCard from './applicationCard.vue';

export default {
  components: {
    applicationCard,
  },
  data() {
    return {
      header: mockData.application.header,
      disableCard: false,
      totalApplications: null,
    };
  },

  computed: {
    fulfill_sync_details() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details;
    },

    applications_details() {
      return this.fulfill_sync_details.pages?.applications;
    },

    isApplyButtonVisible() {
      return this.applications_details?.view_button
        && (!this.applications_details?.view_button?.visible_only_when_no_content
          || (this.applications_details?.view_button?.visible_only_when_no_content
            && this.totalApplications === 0))
        && this.applications_details?.view_button?.visible
    },
  },

  methods: {
    updateApplicationSize(size) {
      this.totalApplications = size;
    }
  }
}
</script>
